import React from 'react';
import { FormattedMessage } from 'react-intl';

import { currencyTools } from './currencyTools';
import { REASONABLE_EXPLANATIONS_LIST } from '../../constants/ssap/hhmTypes/dropdownOptions';


export const helperFunctions = {
    getValueForSSN : (socialSecurityNumber, reasonableExplanationForNoSSN) => {
        return socialSecurityNumber ?
            socialSecurityNumber :
            ( reasonableExplanationForNoSSN ? 
                <FormattedMessage 
                    id='common.summary_ssn_explanation'
                    values={{
                        reason: <FormattedMessage id={REASONABLE_EXPLANATIONS_LIST[reasonableExplanationForNoSSN]}/>
                    }}
                /> :
                <FormattedMessage id='common.not_applicable'/>
            );
    },

    getIncomeValueForRender : (projectedIncome, reportedIncome) => {
        const valueForRender = projectedIncome ?
            projectedIncome :
            reportedIncome;
        return currencyTools.getMoneyFormat(valueForRender, true);
    },

    getMemberName: (member) => {
        return `${member.firstName} ${member.middleName ? member.middleName : ''} ${member.lastName} ${member.suffix ? member.suffix : ''}`;
    },
};
